import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CellContainer = styled.div`

`;

const ExpandableArea = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')}
`;

class ExpandableCell extends Component {
  toggleVisible = () => {
    this.props.toggleVisibility();
  }

  render() {
    const { content, expandableContent } = this.props;
    return (
      <CellContainer onClick={this.toggleVisible}>
        {content}
        <ExpandableArea visible={this.props.expanded}>{expandableContent}</ExpandableArea>
      </CellContainer>
    );
  }
}

ExpandableCell.defaultProps = {
  content: '',
  expandableContent: '',
  expanded: false,
  toggleVisibility: () => {}
};

ExpandableCell.propTypes = {
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  expandableContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  expanded: PropTypes.bool,
  toggleVisibility: PropTypes.func,
};

export default ExpandableCell;



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/ExpandableCell.js